/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type FineKinneyHazardFrequencyDefinitionDto = {
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    deleted?: boolean;
    id?: string;
    firmId?: string;
    predefinedId?: string;
    source?: FineKinneyHazardFrequencyDefinitionDto.source;
    label?: string;
    value?: string;
}

export namespace FineKinneyHazardFrequencyDefinitionDto {

    export enum source {
        SYSTEM = 'SYSTEM',
        USER_DEFINED = 'USER_DEFINED',
    }


}
